import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import actionsReducer from './actionsReducer'
import adminReducer from './adminReducer'
import authReducer from './authReducer'
import brokeringReducer from './brokeringReducer'
import contentReducer from './contentReducer'
import profileReducer from './profileReducer'
import ordersReducer from './ordersReducer'

export default (history) => combineReducers({
  router: connectRouter(history),
  actions: actionsReducer,
  admin: adminReducer,
  auth: authReducer,
  brokering: brokeringReducer,
  content: contentReducer,
  orders: ordersReducer,
  profile: profileReducer
});




// WEBPACK FOOTER //
// ./src/store/reducers/rootReducer.jsx